import { formatDateWithTime } from 'modules/utils/DateUtils';
import { useDispatch, useSelector } from 'react-redux';
import { EducationCounts, EducationItem } from 'store/education/types';
import { getEducationList } from 'store/education/actions';
import * as selectors from 'store/education/selectors';

interface PatientEducationHookValues {
  complete: EducationItem[];
  counts: EducationCounts;
  data: EducationItem[];
  error: Error | null;
  incomplete: EducationItem[];
  lastUpdated: string;
  loading: boolean;
  refetch: (useRequestState?: boolean) => Promise<void>;
}

export default function usePatientEducation(): PatientEducationHookValues {
  const dispatch = useDispatch();

  const complete = useSelector(selectors.patientEducationCompleteDataSelector) || [];
  const counts = useSelector(selectors.patientEducationDataCountSelector);
  const data = useSelector(selectors.patientEducationListDataSelector) || [];
  const error = useSelector(selectors.patientEducationListErrorSelector);
  const incomplete = useSelector(selectors.patientEducationIncompleteDataSelector) || [];
  const lastUpdated = formatDateWithTime(
    useSelector(selectors.patientEducationLastUpdatedSelector)
  );
  const loading = useSelector(selectors.patientEducationListFetchingSelector);
  // wrapped in promise to wait for new education list results before moving on to
  // the next assignment.
  const refetch = async (useRequestState = false) => {
    await dispatch(getEducationList(useRequestState));
  };

  return { complete, counts, data, error, incomplete, lastUpdated, loading, refetch };
}
